export default __webpack_public_path__ + "static/media/Family.a0cbd522.jpg";